import { render, staticRenderFns } from "./schdule-detail.vue?vue&type=template&id=7019c32b&scoped=true"
import script from "./schdule-detail.vue?vue&type=script&lang=js"
export * from "./schdule-detail.vue?vue&type=script&lang=js"
import style0 from "./schdule-detail.vue?vue&type=style&index=0&id=7019c32b&prod&lang=scss&scoped=true"
import style1 from "./schdule-detail.vue?vue&type=style&index=1&id=7019c32b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7019c32b",
  null
  
)

export default component.exports